export const DOMAIN_PROCESS = [
	{ domain: 'sara.bsecure.app', catalog: process.env.REACT_APP_BSECURE_TEST_STORE },
	{
		domain: process.env.REACT_APP_CUSTOM_DOMAIN_STORE_URL,
		catalog: process.env.REACT_APP_CUSTOM_DOMAIN_CATALOG_NAME,
	},
]
